<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" persistent>
    <v-card>
        <v-card-title class="text-h5">{{ title }}</v-card-title>
        <v-card-text v-show="!!message">{{ message }}</v-card-text>
        <v-card-actions>
            <v-btn @click.native="cancel" depressed> {{ this.$t('orderModals.no') }} </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.native="agree" color="secondary" depressed> {{ this.$t('orderModals.yes') }} </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 350,
      zIndex: 200
    }
  }),
  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
